import { useState } from 'react';

import {
    Drawer,
    DrawerContent,
    DrawerDescription,
    DrawerHeader,
    DrawerTitle,
} from '@rocco/components/drawer';
import { Comments } from '../components/Comments';

export const useCommentDialog = () => {
    const [itemId, setItemID] = useState<number | null>(null);

    const openDialog = (id: number) => {
        setItemID(id);
    };
    const closeDialog = () => setItemID(null);

    const commentDialog = () => (
        <Drawer
            open={!!itemId}
            onOpenChange={(open) => !open && closeDialog()}
            direction="right"
        >
            <DrawerContent
                className="data-[vaul-drawer-direction=right]:sm:max-w-[40rem]"
                variant="default"
                overlayVariant="dark"
                noHandle={true}
                scrollable={true}
            >
                <div className="px-6 py-4 md:px-8 md:py-8">
                    <div className="mb-8">
                        <DrawerHeader className="px-0">
                            <DrawerTitle className="text-2xl font-medium text-gray-900">
                                Comments
                            </DrawerTitle>
                            <DrawerDescription className="mt-2 text-gray-600">
                                Leave a comment on this pin.
                            </DrawerDescription>
                        </DrawerHeader>
                    </div>
                </div>

                {itemId && <Comments itemId={itemId} />}
            </DrawerContent>
        </Drawer>
    );

    return { openDialog, closeDialog, commentDialog };
};
